import React from "react";
import { Spinner } from "reactstrap";

export default function DocumentPdfPreview({ pdf, title }) {
  return (
    <div className="px-3 mb-3">
      {pdf.error ? (
        <div role="alert" className="text-center py-5">
          <p>Unable to generate the PDF. Please try again.</p>
          <button className="btn blue-button" onClick={pdf.retry}>Retry PDF</button>
        </div>
      ) : !pdf.ready ? (
        <div role="status" className="d-flex justify-content-center align-items-center gap-2 py-5">
          <Spinner size="sm" /> Preparing PDF...
        </div>
      ) : (
        <>
          <iframe
            data-pdf-preview
            title={`${title} PDF preview`}
            src={pdf.url}
            style={{ width: "100%", height: "80vh", minHeight: "500px", border: "1px solid #dee2e6" }}
          />
          <div className="text-end mt-2">
            <a href={pdf.url} target="_blank" rel="noopener noreferrer">Open / Print PDF</a>
          </div>
        </>
      )}
    </div>
  );
}
